// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__UX0pL","productName":"Table_productName__127xq"};